import { DefaultGroupsNames } from '@modeso/types__aumico-lib-templates-be';

export const BALANCE_DEFAULT_GROUPS: string[] = [DefaultGroupsNames.ASSETS, DefaultGroupsNames.LIABILITIES];
